import { ClientScoreHealthRangeProps } from '..';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { LIQUID_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS } from './constants';
import { LIQUID_TERM_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';

export function ClientLiquidTermScoreHealthRange(props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>) {
  return (
    <ClientScoreHealthRange
      {...props}
      element={LIQUID_TERM_SCORECARD_ELEMENT_SYMBOL}
      breakpoints={LIQUID_TERM_SCORE_HEALTH_RANGE_BREAKPOINTS}
    />
  );
}
